// removed by extract-text-webpack-plugin
module.exports = {"stars":"StarRating-m__stars___22gw0","star":"StarRating-m__star___1EQZp","filled":"StarRating-m__filled___wkzTQ"};


//////////////////
// WEBPACK FOOTER
// ./components/starRating/StarRating.m.sass
// module id = find
// module chunks = 0